import { render, staticRenderFns } from "./MasterBill.vue?vue&type=template&id=54321834&scoped=true&"
import script from "./MasterBill.vue?vue&type=script&lang=js&"
export * from "./MasterBill.vue?vue&type=script&lang=js&"
import style0 from "./MasterBill.vue?vue&type=style&index=0&id=54321834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54321834",
  null
  
)

export default component.exports